import { NavLink, Outlet } from 'react-router'
import { PageHeader } from '@/components/Card'
import { RequireAdmin } from '@/components/RequireAuth'

const TABS = [
  { to: '/admin', label: 'Users', end: true },
  { to: '/admin/invites', label: 'Invites' },
  { to: '/admin/profiles', label: 'Profiles' },
  { to: '/admin/downloads', label: 'Downloads' },
  { to: '/admin/activity', label: 'Activity' },
  { to: '/admin/announce', label: 'Announce' },
]

export function AdminLayout() {
  return (
    <RequireAdmin>
      <div className="space-y-5">
        <PageHeader title="Admin" description="Accounts, invites and what the server is doing." />

        {/*
          One line, always. On a phone the strip scrolls edge to edge with no
          visible scrollbar rather than wrapping into a second row that would
          shift the content below it every time a tab changes.
        */}
        <nav
          aria-label="Admin sections"
          className="-mx-4 overflow-x-auto px-4 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          <ul className="flex min-w-max border-b border-line">
            {TABS.map((tab) => (
              <li key={tab.to}>
                <NavLink
                  to={tab.to}
                  end={tab.end}
                  className={({ isActive }) =>
                    `signage relative flex min-h-11 items-center px-3.5 text-[10px] transition ${
                      isActive ? 'text-accent' : 'text-muted hover:text-ink'
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {tab.label}
                      {isActive ? (
                        <span aria-hidden className="absolute inset-x-0 -bottom-px h-0.5 bg-accent" />
                      ) : null}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <Outlet />
      </div>
    </RequireAdmin>
  )
}
